import React from "react";

const IngredientsTable = ({
  ingredients,
  loadingIngredients,
  openEditIngredient,
  setAddIngredientStockItem,
  setAddIngredientStockQuantity,
  setResetIngredientItem,
  setResetIngredientNewQty,
  setDeleteIngredientItem,
  setError,
  editMode,
  editForm,
  handleFormChange,
  handleEditClick,
  handleCancelEdit,
  handleSave,
}) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead className="bg-slate-50 text-xs uppercase text-slate-500">
          <tr>
            <th className="px-6 py-3 font-semibold">Name</th>
            <th className="px-6 py-3 font-semibold text-slate-500">Total Available</th>
            <th className="px-6 py-3 font-semibold text-orange-600">Total Used</th>
            <th className="px-6 py-3 font-semibold text-violet-600">Remaining</th>
            <th className="px-6 py-3 font-semibold text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {loadingIngredients ? (
            <tr>
              <td colSpan="5" className="px-6 py-8 text-center text-slate-500">
                Loading ingredients...
              </td>
            </tr>
          ) : ingredients.length === 0 ? (
            <tr>
              <td colSpan="5" className="px-6 py-8 text-center text-slate-500">
                No ingredients found.
              </td>
            </tr>
          ) : (
            ingredients.map((ing) => {
              const isEditingUsed = editMode?.id === ing.id && editMode?.field === "used";

              return (
                <tr key={ing.id} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-4 font-medium text-slate-900 group">
                      <div className="flex items-center gap-1">
                        <span>{ing.name}</span>
                        <button
                          onClick={() => handleEditClick(ing, "name")}
                          className="p-1 hover:bg-violet-100 rounded transition-opacity text-violet-400 hover:text-violet-600 opacity-100 sm:opacity-0 sm:group-hover:opacity-100"
                          title="Edit Name"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.89 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.89l12.67-12.67Z"
                            />
                          </svg>
                        </button>
                      </div>
                  </td>
                  <td className="px-6 py-4 font-bold text-slate-700 text-base sm:text-lg">
                    {Math.floor(ing.total_stock)}
                  </td>
                  <td className="px-6 py-4 font-bold text-orange-500 text-base sm:text-lg group">
                    {isEditingUsed ? (
                      <input
                        type="number"
                        name="quantity_used"
                        value={editForm.quantity_used}
                        onChange={handleFormChange}
                        onBlur={() => setTimeout(handleCancelEdit, 200)}
                        autoFocus
                        className="w-20 rounded border border-slate-300 px-2 py-1 text-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
                        min="0"
                        step="1"
                      />
                    ) : (
                      <div className="flex items-center gap-1">
                        <span>
                          {Math.floor(ing.quantity_used || 0)}
                        </span>
                        <button
                          onClick={() => handleEditClick(ing, "used")}
                          className="p-1 hover:bg-orange-100 rounded transition-opacity text-orange-400 hover:text-orange-600 opacity-100 sm:opacity-0 sm:group-hover:opacity-100"
                          title="Log Usage"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.89 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.89l12.67-12.67Z"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4 font-black text-violet-600 text-xl sm:text-2xl">
                    {editMode?.id === ing.id && editMode?.field === "used"
                      ? Math.floor(ing.total_stock - (parseInt(editForm.quantity_used || 0, 10)))
                      : Math.floor(ing.quantity)}
                  </td>
                  <td className="px-6 py-4 text-right flex justify-end items-center gap-2">
                    {editMode?.id === ing.id ? (
                      <div className="flex justify-end gap-2">
                        <button
                          onClick={handleSave}
                          className="rounded bg-emerald-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-emerald-600"
                        >
                          Save
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          className="rounded bg-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-300"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            setAddIngredientStockItem(ing);
                            setAddIngredientStockQuantity("");
                          }}
                          className="whitespace-nowrap rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-700 hover:bg-emerald-100 transition-colors"
                        >
                          + Add
                        </button>
                        <button
                          onClick={() => {
                            if (ing.quantity > 0) {
                              setError("You must exhaust a stock entirely before you can reset the values.");
                              setTimeout(() => setError(null), 3000);
                              return;
                            }
                            setResetIngredientItem(ing);
                            setResetIngredientNewQty("0");
                          }}
                          className="rounded-lg border border-red-200 px-3 py-1.5 text-xs font-medium text-red-600 hover:bg-red-50 hover:border-red-300 transition-colors"
                        >
                          Reset
                        </button>
                        <button
                          onClick={() => setDeleteIngredientItem(ing)}
                          className="p-1.5 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors"
                          title="Delete"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                            />
                          </svg>
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default IngredientsTable;
